import axios from 'axios';
import { apiDomain, googleGeocodeUrl } from '@/config';

import * as types from './types';

const actions = {
  reset: ({ commit }) => {
    commit(types.RESET);
  },
  async fetchCompany({ commit }, id) {
    commit(types.FETCH_COMPANY_PENDING);
    try {
      const response = await axios.get(`${apiDomain}company/${id}`);
      commit(types.FETCH_COMPANY_FULFILLED, response);
      return Promise.resolve(response.data);
    } catch (error) {
      commit(types.FETCH_COMPANY_ERROR);
      return Promise.reject(error);
    }
  },
  async storeCompany({ commit, dispatch }, form) {
    commit(types.STORE_COMPANY_PENDING);
    try {
      // Refetch location
      const addressParts = [
        form.street,
        form.street_number,
        form.zip,
        form.place,
        form.country,
      ];
      const { lat, lng } = await dispatch('fetchLocation', { address: addressParts, hideMessages: true });
      form.latitude = lat;
      form.longitude = lng;
      const method = form.id ? 'POST' : 'POST'; // TODO Update with PUT not POST
      const url = form.id ? `${apiDomain}company/${form.id}` : `${apiDomain}auth/company/register`;
      const response = await axios({ url, method, data: form });
      await Promise.all([
        dispatch('company/fetchCompanies', null, { root: true }),
        dispatch('checkCompanyProfile', {
          companyId: response.data.data.id,
          forceCheck: !form.id,
        }),
      ]);
      commit(types.STORE_COMPANY_FULFILLED);
      const successMessage = form.id ? 'alert.updateCompanyProfileSuccessful' : 'alert.addCompanySuccessful';
      dispatch('messages/showMessage', { key: successMessage, color: 'success' }, { root: true });
      return Promise.resolve(response.data.data);
    } catch (error) {
      commit(types.STORE_COMPANY_ERROR);
      const errorMessage = form.id ? 'alert.updateCompanyProfileError' : 'alert.addCompanyError';
      dispatch('messages/showMessage', { key: errorMessage, color: 'error' }, { root: true });
      return Promise.reject(error);
    }
  },
  async fetchLocation({ commit, dispatch }, { address, hideMessages }) {
    commit(types.FETCH_LOCATION_PENDING);
    try {
      const plainAxios = axios.create();
      const key = 'AIzaSyAXoDMo2aSoMdM7H9mxngR9V2icJx_DuAI';
      const response = await plainAxios.get(`${googleGeocodeUrl}${address.join()}&key=${key}`);
      if (!hideMessages) {
        dispatch('messages/showMessage', { key: 'alert.updateLocationSuccessful', color: 'success' }, { root: true });
      }
      commit(types.FETCH_LOCATION_FULFILLED);
      return Promise.resolve(response.data.results[0].geometry.location);
    } catch (error) {
      commit(types.FETCH_LOCATION_ERROR);
      dispatch('messages/showMessage', { key: 'alert.updateLocationError', color: 'error' }, { root: true });
      return Promise.reject(error);
    }
  },
  async checkCompanyProfile({ state, commit }, { companyId, forceCheck }) {
    if (state.profileCompleted && !forceCheck) {
      return true;
    }
    commit(types.CHECK_COMPANY_PROFILE_PENDING);
    try {
      const response = await axios.get(`${apiDomain}company/${companyId}/complete`);
      commit(types.CHECK_COMPANY_PROFILE_FULFILLED, response.data);
      return true;
    } catch (error) {
      commit(types.CHECK_COMPANY_PROFILE_ERROR);
      return Promise.reject(error);
    }
  },
  async fetchContactPerson({ commit }, id) {
    commit(types.FETCH_CONTACT_PERSON_PENDING);
    try {
      const response = await axios.get(`${apiDomain}company/${id}/contactperson`);
      commit(types.FETCH_CONTACT_PERSON_FULFILLED, response);
      return true;
    } catch (error) {
      commit(types.FETCH_CONTACT_PERSON_ERROR);
      return Promise.reject(error);
    }
  },
  async storeContactPerson({ commit, dispatch }, { companyId, form }) {
    commit(types.STORE_CONTACT_PERSON_PENDING);
    try {
      const method = form.id ? 'PATCH' : 'POST';
      const contactPersonUrl = `${apiDomain}company/${companyId}/contactperson`;
      const url = form.id ? `${contactPersonUrl}/${form.id}` : contactPersonUrl;
      const response = await axios({ url, method, data: form });
      await dispatch('checkCompanyProfile', { companyId, forceCheck: false });
      dispatch('messages/showMessage', { key: 'alert.updateContactPersonSuccessful', color: 'success' }, { root: true });
      commit(types.STORE_CONTACT_PERSON_FULFILLED);
      return response;
    } catch (error) {
      commit(types.STORE_CONTACT_PERSON_ERROR);
      dispatch('messages/showMessage', { key: 'alert.updateContactPersonError', color: 'error' }, { root: true });
      return Promise.reject(error);
    }
  },
};

export default actions;
